import React from 'react';
import './WhoWeAreBox.css';
import { Link } from 'react-router';

const WhoWeAreBox = ({personInfo}) => {
  return (
    <div className='col span-1-of-3 box text-center who-we-are'>
      <h3 className='text-center'><Link to={personInfo.link}>{personInfo.name}</Link></h3>
      <img src={personInfo.imgSrc} alt={personInfo.imgAltText} className='portrait-img' />
      {(personInfo.link ) ? <p><Link to={personInfo.link}>Learn more about {personInfo.name}</Link></p> : ''}
    </div>
  )
}

export default WhoWeAreBox;



// WEBPACK FOOTER //
// ./src/components/WhoWeAreBox.js